import moment from 'moment';

export const colors = ['#005680', '#e2b900', '#d1e2ed', '#0a92bc', '#50bc9d', '#38d0e5', '#e3fffe', '#006971', '#1f344c', '#990707', '#915223', '#e48f00', '#d5ecf2', '#ffda00', '#f5f1db']
export const months = ['Jan', 'Feb', 'Mar', 'Apr', 'Mai', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Des']
export const monthNumbers = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]

export const multiSelectOptions = {
    noResult: 'Ingen treff',
    noOptions: 'Ingen alternativer',
    placeholder: 'Velg',
    selectLabel: 'Trykk enter for å velge',
    selectedLabel: 'Valgt',
    deselectLabel: 'Trykk enter for å fjerne'
}

export const ranges = [
    { key: 'thisYear', label: 'I år', value: 'year' },
    { key: 'lastYear', label: 'I fjor', value: '-year' },
    { key: 'thisQuarter', label: 'Kvartal', value: 'quarter' },
    { key: 'thisMonth', label: 'Denne måneden', value: 'month' },
    { key: 'lastMonth', label: 'Forrige måned', value: '-month' },
    { key: 'lastWeek', label: 'Forrige uke', value: '-isoWeek' },
];

export const colorPalete = {
    priBlue: '#005680',
    darkBlue: '#00496C',
    lightBlue: '#00B5F1',
    textBlue: '#003047',
    bkgdGrey: '#f4f6f9',
    primLightBlue: '#8cd8fc',
    priGold: '#e2b900',
    priLightBlue: '#d1e2ed',
    priLightBlue04: '#d1e2ed66',
    priLightBlue02: '#d1e2ed33',
    
    secBlue: '#0a92bc',
    secLightGreen: '#50bc9d',
    secCyan: '#38d0e5',
    secLightBlue: '#e3fffe',
    secGreen: '#006971',
    secDarkBlue: '#1f344c',
    secRed: '#990707',
    secBrown: '#915223',
    
    terCyan: '#4df4e8',
    terRed: '#ff3939',
    terYellow: '#fff200',
    terBrowm: '#ffa31d',
}

export const maxDate = moment().subtract(1, 'week').endOf('isoWeek').format("YYYY-MM-DD");
export const minDate = moment().subtract(4, 'years').startOf("year").format("YYYY-MM-DD");


// WEBPACK FOOTER //
// ./Scripts/app/data/constants.js